module.exports = __webpack_public_path__ + "static/theme-editor-show-banner-on-products-by-category-0f01dd86922f066310f9c759efbd9eb4.png";